import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Container, Button } from '../ui';

const HeaderWrapper = styled.header`
  position: sticky; top: 0; z-index: 100;
  background: white; border-bottom: 1px solid #e5e7eb;
`;

const HeaderInner = styled.div`
  display: flex; align-items: center; justify-content: space-between; height: 72px;
`;

const Logo = styled(Link)`
  font-size: 1.25rem; font-weight: 700; color: #0f0f0f; text-decoration: none;
  display: flex; align-items: center; gap: 0.5rem;
  &:hover { color: #0f0f0f; }
`;

const LogoMark = styled.img`
  width: 32px; height: 32px; border-radius: 0.5rem;
`;

const Nav = styled.nav`
  display: flex; align-items: center; gap: 2rem;
  @media (max-width: 768px) { display: none; }
`;

const NavLinks = styled.div`
  display: flex; align-items: center; gap: 1.5rem;
`;

const NavLink = styled(Link)`
  color: ${({ $active }) => $active ? '#0f0f0f' : '#6b7280'};
  font-weight: 500; text-decoration: none;
  &:hover { color: #0f0f0f; }
`;

const MobileBtn = styled.button`
  display: none; background: none; border: none; padding: 0.5rem; color: #0f0f0f;
  @media (max-width: 768px) { display: flex; align-items: center; justify-content: center; }
`;

const MobileMenu = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: ${({ $open }) => $open ? 'flex' : 'none'};
    flex-direction: column; gap: 1rem; padding: 1.5rem;
    border-top: 1px solid #e5e7eb;
  }
`;

const MobileLink = styled(Link)`
  color: #374151; font-weight: 500; font-size: 1.125rem; padding: 0.5rem 0;
`;

const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const items = [
    { path: '/', label: 'Home' },
    { path: '/shop', label: 'Shop' },
    { path: '/about', label: 'About' },
    { path: '/media', label: 'Media' },
  ];

  return (
    <HeaderWrapper>
      <Container>
        <HeaderInner>
          <Logo to="/"><LogoMark src="/logo.png" alt="The New Calendar" />The New Calendar</Logo>
          <Nav>
            <NavLinks>
              {items.map(i => <NavLink key={i.path} to={i.path} $active={pathname === i.path}>{i.label}</NavLink>)}
            </NavLinks>
            <Button as={Link} to="/shop" size="sm">Buy Now</Button>
          </Nav>
          <MobileBtn onClick={() => setOpen(!open)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              {open ? <path d="M6 18L18 6M6 6l12 12" /> : <path d="M4 6h16M4 12h16M4 18h16" />}
            </svg>
          </MobileBtn>
        </HeaderInner>
      </Container>
      <MobileMenu $open={open}>
        <Container>
          {items.map(i => <MobileLink key={i.path} to={i.path} onClick={() => setOpen(false)}>{i.label}</MobileLink>)}
          <Button as={Link} to="/shop" $fullWidth style={{ marginTop: '8px' }}>Buy Now</Button>
        </Container>
      </MobileMenu>
    </HeaderWrapper>
  );
};

export default Header;
